export const TOKENS = {
  brandTeal: '#00415A',
  teal700: '#013247',
  ink900: '#0E1B22',
  ink700: '#29373F',
  ink400: '#71808A',
  ink300: '#97A4AC',
  line300: '#C5D0D7',
  line200: '#DBE2E7',
  line100: '#EAEFF2',
  surface0: '#FFFFFF',
  surface50: '#F3F6F8',
  panelHead: '#F0F4F6',
  sidebar: '#f8fafc',
  blue50: '#E7F3F8',
  blue600: '#006A93',
}

export const FONT_SANS = "'Archivo', system-ui, -apple-system, sans-serif"
export const FONT_MONO =
  "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace"

export const GRID_SX = {
  '& .MuiDataGrid-root': {
    border: 'none',
    fontFamily: FONT_SANS,
    color: TOKENS.ink900,
    '--DataGrid-rowBorderColor': TOKENS.line100,
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: `1px solid ${TOKENS.line300}`,
    },
    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--pinnedLeft': {
      backgroundColor: `${TOKENS.panelHead} !important`,
      color: `${TOKENS.ink400} !important`,
      borderRadius: 0,
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
      { outline: 'none' },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontFamily: FONT_SANS,
      fontSize: 10.5,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: TOKENS.ink400,
    },
    '& .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton':
      { color: TOKENS.ink400 },
    '& .MuiDataGrid-columnSeparator': { display: 'none' },
    '& .MuiDataGrid-cell': {
      fontFamily: FONT_SANS,
      fontSize: 12,
      color: TOKENS.ink900,
      '&:focus, &:focus-within': { outline: 'none' },
    },
    '& .MuiDataGrid-cell--withRightBorder, & .MuiDataGrid-columnHeader--withRightBorder':
      { borderRight: 'none' },
    '& .MuiDataGrid-row.row--odd, & .MuiDataGrid-row.row--odd .MuiDataGrid-cell':
      { backgroundColor: TOKENS.surface50 },
    '& .MuiDataGrid-row.row--even, & .MuiDataGrid-row.row--even .MuiDataGrid-cell':
      { backgroundColor: TOKENS.surface0 },
    '& .MuiDataGrid-row:hover, & .MuiDataGrid-row:hover .MuiDataGrid-cell': {
      backgroundColor: TOKENS.blue50,
    },
    '& .MuiDataGrid-footerContainer': {
      fontFamily: FONT_SANS,
      minHeight: 40,
      borderTop: `1px solid ${TOKENS.line200}`,
    },
    '& .MuiTablePagination-root, & .MuiTablePagination-root *': {
      fontFamily: FONT_SANS,
      fontSize: 12,
    },
    '& .sch-num': {
      fontFamily: FONT_MONO,
      fontVariantNumeric: 'tabular-nums',
      letterSpacing: '-0.02em',
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
  },
}
